import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { List, ListItem, makeSelectable } from 'material-ui/List';
import Avatar from 'material-ui/Avatar';
import FileFolder from 'material-ui/svg-icons/file/folder';
import FontIcon from 'material-ui/FontIcon';
import Subheader from 'material-ui/Subheader';

import Icon from '../Common/Icon';
import { fetchJobProfiles } from '../../actions/jobprofiles';

import styles from './styles';

const SelectableList = makeSelectable(List);

class JobProfileDrilldown extends React.Component {
  static propTypes = {
    jobProfile: PropTypes.object,
    fetchJobProfiles: PropTypes.func.isRequired,
    jobProfiles: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
  };

  state = {
    // jobProfile: {},
  };

  componentWillMount() {
    this.props.fetchJobProfiles();
  }

  handleSelectJobProfile = (evt, jobProfileId) => {
    console.log('handleSelectJobProfile', jobProfileId);
    const jobProfile = this.props.jobProfiles.find((jp) => jp.id === jobProfileId);
    // this.setState({
    //   jobProfile,
    // });
    console.log('calling onChange', jobProfile);
    this.props.onChange(jobProfile);
  };

  renderJobProfileListItem(jobProfile) {
    console.log('renderItem', jobProfile);
    return (<ListItem
      key={jobProfile.id}
      value={jobProfile.id}
      leftAvatar={<Avatar icon={<FileFolder />}/>}
      rightIcon={<FontIcon className="material-icons" style={styles.stageIcon}>chevron_right</FontIcon>}
      primaryText={jobProfile.name}
    />);
  }

  renderJobProfileStageListItem(stage) {
    return (<ListItem
      key={stage.id}
      leftAvatar={<Avatar
        icon={<Icon style={styles.stageIcon} name={stage.icon || 'barcode'}/>}/>}
      primaryText={stage.name}
      secondaryText={stage.description}
    />);
  }

  renderJobProfileStages(stages = []) {
    return (<div style={styles.jobProfileStages}>
      <Subheader>Stages</Subheader>
      <List>
        { stages.map(this.renderJobProfileStageListItem)}
      </List>
    </div>);
  }

  render() {
    const jobProfile = this.props.jobProfile || {};
    console.log('jobProfile', jobProfile);
    return (<div style={styles.container}>
      <div style={styles.jobProfiles}>
        <Subheader>Job Profiles</Subheader>
        <SelectableList
          value={jobProfile.id}
          onChange={this.handleSelectJobProfile}>
          { this.props.jobProfiles.map(this.renderJobProfileListItem)}
        </SelectableList>
      </div>
      { this.renderJobProfileStages(jobProfile.stages) }
    </div>);
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchJobProfiles,
  }, dispatch);
}

function mapStateToProps(state) {
  return {
    jobProfiles: state.get('jobprofiles').get('jobProfiles').toJS(),
    loadingJobProfiles: state.get('jobprofiles').get('loading'),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(JobProfileDrilldown);



// WEBPACK FOOTER //
// ./src/components/JobProfileDrilldown/index.js